module.exports = __webpack_public_path__ + "img/coastCleanUp_041022_C.cb7594f6.jpg";